export default "__VITE_ASSET__DJVaPs$o__"